/* unplugin-vue-components disabled */import { render } from "./DeviceBssid.vue?vue&type=template&id=1a1a4fff&scoped=true"
import script from "./DeviceBssid.vue?vue&type=script&lang=js"
export * from "./DeviceBssid.vue?vue&type=script&lang=js"

import "./DeviceBssid.vue?vue&type=style&index=0&id=1a1a4fff&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1a4fff"]])

export default __exports__